module.exports = __webpack_public_path__ + "static/media/ic_reload_player.2ccf56ac.svg";